export default __webpack_public_path__ + "resources/icons/d431-2e83.webp";